import Model from 'flarum/Model';

export default class UniLoginUser extends Model {}

Object.assign(UniLoginUser.prototype, {
  id: Model.attribute('id'),
  institutionId: Model.attribute('institution_id'),
  institutionName: Model.attribute('institution_name'),
  unilogin: Model.attribute('unilogin')
});
